export default {
    name: 'support',
    props: {
        status: {
            type: String,
            default: 'quoreid'
        }
    },
    // Initial data.
    data() {
        return {
            buttonClasses: ['is-fullwidth']
        };
    },
    // Methods needed for this component.
    methods: {
        // Transition to LoginForm on click of Back to Login link.
        onClickBackToLogin(e) {
            e.preventDefault();
            this.$emit('currentView', 'login-form');
            this.$emit('currentTransition', 'component-slide-fade-down');
            this.$emit('currentAlert', null);
        }
    }
};
